<template>
    <div class="body">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-if="shopData.title1Flg==1">
                <img :src="'http://wx.yunzhineng.top:8888/'+shopData.title1Img" alt=""  @click="toUrlHtml(shopData.title1Url)">
            </van-swipe-item>
             <van-swipe-item v-if="shopData.title2Flg==1">
                <img :src="'http://wx.yunzhineng.top:8888/'+shopData.title2Img" alt=""  @click="toUrlHtml(shopData.title2Url)">
            </van-swipe-item>
             <van-swipe-item v-if="shopData.title3Flg==1">
                <img :src="'http://wx.yunzhineng.top:8888/'+shopData.title3Img" alt=""  @click="toUrlHtml(shopData.title3Url)">
            </van-swipe-item>
        </van-swipe> 
        <div class="content">
            <div class="weacher">
                <div class="weacher-r">
                    <van-icon name="volume-o" size="22" />
                    <div class="notice-box">系统公告：{{ shopData.shopNotice }}</div>
                </div>
            </div>
        </div>
        <!-- <div class="banner">
            <div class="l">直属专营店</div>
            <div class="r">品质保障 售后无忧</div>
        </div> -->

        <!-- 商品列表 -->
        <div class="group">
            <!-- 使用flex容器包裹列表项 -->
            <div class="list-container">
                <div class="list" v-for="(item, index) in dataList" :key="index" @click="linkOpen(item)">
                    <div class="list-img">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="list-content">
                        <div class="top">{{ item.shareName }}</div>
                        <div class="remark" v-if="item.shopRemark && item.shopRemark != 'null'">{{ item.shopRemark }}</div>
                    </div>
                    <div class="r-btn">
                        <div class="price">￥{{ item.sharePrice }}</div>
                        <div class="btn">立即购买</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="f-tab">
            <van-tabbar v-model="active" @change="onChange">
                <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                <van-tabbar-item icon="service-o">客服</van-tabbar-item>
                <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
            </van-tabbar>
        </div>

    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog, Swipe, SwipeItem } from "vant";
export default {
    data() {
        return {
            dataList: [

            ],
            active: 0,
            wifiList: [],
            pageNo: 0,
            perPageNum: 20,
            allPage: 0,
            agentId: localStorage.getItem('buyAgentId'),
            vanTab: ['WIFI设备', '设备外设'],
            allLoaded: false,
            show: false,
            title: 'MIFI设备',
            iccid: '',

            shopData: {
                title1Img: '',
                title2Img: '',
                title3Img: '',
                title1Flg: '',
                title2Flg: '',
                title3Flg: '',
                shopNotice: '',
                title1Url: '',
                title2Url: '',
                title3Url: '',
            },
        }
    },
    created() {
        this.agentId = this.$route.query.agentId || localStorage.getItem('buyAgentId');
        wxRequest("applyChangeSim/selectShopData", { iccid: this.iccid }, "post").then(res => {
            if (res.data.code === '200') {
                this.shopData=res.data.data;
                localStorage.setItem('buyAgentId', this.agentId);
                this.getAgentPrechargeListHandler()
            }
        })
    },
    methods: {
        toUrlHtml(url){
            if(url){
                window.location.href=url;
            }
        },
        getAgentPrechargeListHandler() {
            this.pageNo += 1;
            var params = {
                pageNo: this.pageNo,
                //   shareType: this.title,
                agentId: this.agentId,
                perPageNum: this.perPageNum,
                iccid: this.iccid
            }
            wxRequest("applyChangeSim/share/group", params, "post").then(res => {
                if (res.data.code == 200) {
                    var data = res.data.data.resultList.map(item => {
                        item.img = process.env.VUE_APP_IMG_URL + '/' + item.shareImg;
                        return item
                    })
                    this.dataList = this.dataList.concat(data)
                }
            })
        },
        toKefuUrl() {
            wxRequest("sim/kefu/url", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code == '200') {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: res.data.message
                    });
                }
            })
        },
        onChange(data) {
            if (data === 1) {
                this.toKefuUrl();
            } else if (data === 2) {
                this.$router.push({ path: '/buy/userInfo' });
            }
        },
        linkOpen(data) {
            window.open(data.newUrl);
            // var loginPhone = localStorage.getItem('myLoginPhone');
            // if (loginPhone && loginPhone.length > 5) {

            // } else {
            //     Dialog.confirm({
            //         title: "注册提示",
            //         message: "请先注册信息后，再进行购买操作。 点击 确定 即可前往注册。"
            //     })
            //         .then(() => {
            //             this.$router.push({ path: '/buy/login' });
            //         })
            //         .catch(() => { });
            // }
        }
    }
}
</script>
<style lang="less" scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #333;
    background-color: #f5f7fa;
    line-height: 1.5;
}

.body {
    width: 100%;
    box-sizing: border-box;
    background: linear-gradient(180deg, #f0f7ff 0%, #e6f0ff 100%);
    padding: 5px;
    position: relative;
    padding-bottom: 50px;
    min-height: 100vh;
}

// 轮播图样式
.my-swipe {
    height: 180px;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 8px;

    .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 180px;
        text-align: center;

        img {
            width: 100%;
            height: 180px;
            object-fit: cover;
            display: block;
        }
    }
}

// 公告栏样式
.weacher {
    width: 100%;

    .weacher-r {
        margin-top: 10px;
        height: 48px;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        padding: 0 12px;

        .van-icon-volume-o {
            padding: 0 10px;
            color: #3c85ed;
            flex-shrink: 0;
        }

        .notice-box {
            color: #333;
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex-grow: 1;
        }
    }
}

// 横幅样式
.banner {
    margin-top: 10px;
    padding: 15px;
    color: #fff;
    font-size: 18px;
    border-radius: 8px;
    background: linear-gradient(90deg, #3c85ed 0%, #5a98ff 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 10px rgba(60, 133, 237, 0.2);

    .l {
        font-weight: 500;
    }

    .r {
        font-size: 16px;
        opacity: 0.9;
        font-weight: 400;
    }
}

// 商品列表样式
.group {
    margin-top: 12px;
    margin-bottom: 50px;

    .list-container {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 4px;
    }

    .list {
        width: calc(50% - 4px);
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 12px;
        transition: all 0.2s ease;
        cursor: pointer;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .list-img {
            width: 100%;
            height: 140px;
            margin-bottom: 10px;
            border-radius: 8px;
            overflow: hidden;
            background-color: #f5f5f5;

            img {
                width: 100%;
                height: 100%;
                border-radius: 8px;
                object-fit: cover;
                transition: transform 0.3s ease;

                &:hover {
                    transform: scale(1.05);
                }
            }
        }

        .list-content {
            width: 100%;
            margin-bottom: 10px;
            text-align: center;

            .top {
                font-size: 15px;
                font-weight: 500;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 4px;
            }

            .remark {
                font-size: 12px;
                color: #722ed1;
                /* 高级紫 */
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                line-height: 1.4;
            }
        }

        .r-btn {
            width: 100%;
            text-align: center;
            margin-top: auto;

            .price {
                font-size: 16px;
                color: #e53e3e;
                font-weight: 600;
                margin-bottom: 6px;
            }

            .btn {
                display: inline-block;
                width: 100%;
                height: 32px;
                line-height: 32px;
                background-color: #c53030;
                color: white;
                border-radius: 16px;
                font-size: 14px;
                font-weight: 500;
                transition: background-color 0.2s ease;

                &:hover {
                    background-color: #c53030;
                }
            }
        }
    }
}

// 底部导航样式
.f-tab {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;

    .van-tabbar {
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
        height: 50px;

        .van-tabbar-item {
            padding-top: 5px;
            padding-bottom: 5px;

            .van-tabbar-item__icon {
                font-size: 20px;
                margin-bottom: 2px;
            }

            .van-tabbar-item__text {
                font-size: 12px;
            }
        }

        .van-tabbar-item--active {
            color: #3c85ed;
        }
    }
}

// 其他页面共用样式
.title-name {
    text-align: center;
    font-size: 20px;
    margin-top: 30px;
    font-weight: 500;
    color: #333;
}

.kefu-img {
    width: 260px;
    height: 340px;
    margin: 20px auto;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

    img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;
    }
}

.copyRight {
    left: 0;
    right: 0;
    margin: auto;
    color: #999;
    font-size: 12px;
    text-align: center;
    padding: 15px 0;
    position: absolute;
    bottom: 50px;
}

// 加载状态相关样式
.loading {
    text-align: center;
    padding: 15px;
    color: #666;
    font-size: 14px;

    .van-loading {
        margin-right: 8px;
    }
}

// 空状态样式
.empty {
    text-align: center;
    padding: 40px 20px;
    color: #999;

    .van-icon {
        font-size: 48px;
        margin-bottom: 15px;
        color: #ccc;
    }

    .text {
        font-size: 14px;
    }
}
</style>